import React from 'react'
import './Works.css'
import Upwork from '../../img/Upwork.png'
import Amazon from '../../img/amazon.png'
import Facebook from '../../img/Facebook.png'
import Shopify from '../../img/Shopify.png'
import Fiverr from '../../img/fiverr.png'
import { themeContext } from "../../Context";
import { useContext } from "react";
import { motion } from 'framer-motion'
import { Link } from 'react-scroll'

function Works() {

    const transition = {duration:3,type:'spring'}

    const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="works">
        <div className="awesome">
        <span style={{color:darkMode? 'white' : ''}}>Specialized in these</span>
        <span>Technologies</span>
        <span>I offer a wide range of interactive and<br />dynamic web applications.<br/>I ensure seamless performance and delightful user<br />experience.</span>
        <Link to="contact" smooth={true} spy={true}>
        <button style={{width:'10em',fontSize:'1em',marginTop:'2em'}} className='button s-button' >Hire Me</button>
        </Link>
        <div className="blur2"></div>
        </div>

        {/* right side */}
       <div className="w-right">
        <motion.div
        initial={{rotate:45}}
        whileInView={{rotate:0}}
        viewport={{margin:'-40px'}}
        transition={transition}
        className="w-mainCircle" >
            <div className="w-secCircle" style={{background:darkMode? 'white' : ''}}>
                <a href="https://developer.mozilla.org/en-US/docs/Web/HTML">
                <img src={Upwork} alt="" style={{top:'0em',left:'1.5em'}}/>
                </a>
            </div>
            <div className="w-secCircle" style={{background:darkMode? 'white' : ''}}>
                <a href="https://react.dev/learn">
                <img src={Fiverr} alt="" style={{top:'1em',left:'1em',transform:'scale(1.1)'}}/>
                </a>
            </div>
            <div className="w-secCircle" style={{background:darkMode? 'white' : ''}}>
                <a href="https://nodejs.org/en/docs">
                <img src={Amazon} alt=""  style={{top:'1em',left:'1em',transform:'scale(1.1)'}}/>
                </a>
            </div>
            <div className="w-secCircle" style={{background:darkMode? 'white' : ''}}>
                <a href="https://developer.mozilla.org/en-US/docs/Web/JavaScript">
                <img src={Shopify} alt="" style={{top:'1em',left:'1em',transform:'scale(1.1)'}}/>
                </a>
            </div>
            <div className="w-secCircle" style={{background:darkMode? 'white' : ''}}>
                <a href="https://developer.mozilla.org/en-US/docs/Web/CSS">
                <img src={Facebook} alt="" style={{top:'1em',left:'1em',transform:'scale(1.3)'}}/>
                </a>
            </div>
        </motion.div>
        {/* back circles */}
        <div className="w-backCircle blueCircle"></div>
        <div className="w-backCircle yellowCircle"></div>
        </div> 
    </div>
  )
}

export default Works